'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import type React from 'react';
import TermsOfUseAcceptance from '@/components/TermsOfUseAcceptance/TermsOfUseAcceptance';
import Toast from '@/components/V2/Toast/Toast';
import { LAUNCH_DARKLY_CLIENT_ID } from '@/config/env';
import LDClient from '@/lib/feature-flags/launch-darkly';
import '@/lib/i18n/i18n.config';
interface ProvidersProps {
  children: React.ReactNode;
}
const queryClient = new QueryClient();

/**
 * Providers Component
 *
 * This component wraps the application with all necessary providers:
 * - LaunchDarkly Feature Flags Provider
 * - React Query Provider
 * - Toast Provider
 * - Terms of use acceptance modal (opened by the API error interceptors)
 * - Any other global context providers
 */
function ProvidersComponent(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ReactQueryDevtools />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TermsOfUseAcceptance />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <QueryClientProvider client={queryClient}>{t1}<Toast.Provider>{children}{t2}</Toast.Provider></QueryClientProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
const WrappedProviders = withLDProvider({
  clientSideID: LAUNCH_DARKLY_CLIENT_ID,
  context: LDClient.baseContext,
  options: LDClient.baseOptions
})(ProvidersComponent) as unknown as React.FC<{
  children?: React.ReactNode;
}>;
export function Providers(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <WrappedProviders>{children}</WrappedProviders>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}